const acessarFaturas = ({body, msisdn, tokenRecaptcha, otpToken, otpTokenTrasactionId}) => {
  const query = `msisdn=${msisdn}&page=1&limit=50`
  const path_url = `${process.env.REACT_APP_INVOICES_URL}`
  const payload_body = body ? JSON.stringify(body) : null
  const request_method = 'GET'
  const payload_headers = {}

  //CONFIG
  payload_headers['Accept'] = 'application/json'

  //AUTH
  payload_headers['X-Client-Key'] = process.env.REACT_APP_INVOICES_KEY
  payload_headers['X-Captcha-Token'] = tokenRecaptcha
  payload_headers['X-Otp-Token'] = otpToken
  payload_headers['X-Otp-Token-Transaction-Id'] = otpTokenTrasactionId

  //QUERY
  payload_headers['X-QueryString'] = query

  return fetch(path_url, {'body': payload_body, 'crossDomain': true, 'headers': payload_headers, 'method': request_method})
}

export {acessarFaturas}
